export default "__VITE_ASSET__BwHgii7v__"